import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import CopyIcon from '@material-ui/icons/FileCopyOutlined';
import TextField from '@material-ui/core/TextField';

const useCopyStyles = makeStyles((_theme) => ({
  copyButton: {
    margin: '8px',
  },
  copyContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  copyTextArea: {
    marginTop: 8,
    width: 548,
    // height: 32,
    // backgroundColor: 'transparent'
  },
}));

export default function CopyTextToClipboard({ value, label }: { value: string; label?: string }) {
  const itemsClasses = useCopyStyles();
  const [copySuccess, setCopySuccess] = React.useState('');
  const inputRef = React.useRef<HTMLInputElement>();

  function copyToClipboard(e: any) {
    inputRef.current?.select();
    inputRef.current?.setSelectionRange(0, 99999); /* For mobile devices */

    document.execCommand('copy');
    // This is just personal preference.
    // I prefer to not show the whole text area selected.
    e.target.focus();
    setCopySuccess('Copied!');
    setTimeout(() => setCopySuccess(''), 5000);
  }

  return (
    <div className={itemsClasses.copyContainer}>
      <form>
        <TextField
          variant="standard"
          label={label}
          inputProps={{
            endAdornment: <CopyIcon />,
          }}
          className={itemsClasses.copyTextArea}
          inputRef={inputRef}
          value={value}
        />
      </form>
      {
        /* Logical shortcut for only displaying the
          button if the copy command exists */
        document.queryCommandSupported('copy') && (
          <div>
            <Button
              color="primary"
              className={itemsClasses.copyButton}
              variant="outlined"
              onClick={copyToClipboard}
              startIcon={<CopyIcon />}
            >
              Copy
            </Button>
            {copySuccess}
          </div>
        )
      }
    </div>
  );
}
